<div class="container">
  <div class="auth-container">
    <img
      height="50"
      width="260"
      alt="Softdocs Logo"
      [src]="assetBaseUrl + 'softdocs-logo.png'"
    />
    <h1 id="url-title">{{ currentTranslations.urlVerTitle }}</h1>
    <p class="header-instructions">{{ currentTranslations.urlVerInstruction }}</p>

    <form (ngSubmit)="verifyUrl()">
      <input
        id="url-input"
        class="url-input"
        type="url"
        name="contentURL"
        aria-labelledby="url-title"
        required
        [placeholder]="currentTranslations.enterUrl"
        [attr.aria-describedby]="
          hasAccess === false || invalidUrl ? 'error-message help-text' : 'help-text'
        "
        [attr.aria-invalid]="hasAccess === false || invalidUrl"
        [(ngModel)]="contentURL"
      />

      @if (hasAccess === false || invalidUrl) {
        <div
          id="error-message"
          role="alert"
          aria-live="polite"
        >
          <span class="error-label">
            {{ hasAccess === false ? noAccessMessage : currentTranslations.invalidUrl }}
          </span>
        </div>
      }

      <div
        id="help-text"
        class="help-text-container"
      >
        <span>{{ currentTranslations.helpText }}</span>
        <ul>
          <li>{{ currentTranslations.helpTextBullet1 }}</li>
          <li>{{ currentTranslations.helpTextBullet2 }}</li>
        </ul>
      </div>

      <button
        type="submit"
        class="verify-button"
      >
        {{ currentTranslations.verifyUrl }}
      </button>
    </form>
  </div>
</div>
